import axios from "axios";

export default function getCompanyDisbursement() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaignV2/customerDisbursement/company`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
